import { FormEvent } from 'react';
import styled from 'styled-components';
import { Edit16 } from 'ui/icons/action/Edit16';
import { FormField } from 'ui/formField';
import { GhostButton } from 'ui/button';
import { InputText } from 'ui/inputs/inputText/InputText';
import { heading3, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

type Props = {
  isEditMode: boolean;
  /* Initial Value to Display */
  value: string;
  /** the function to run when the input loses focus */
  onBlur: () => void;
  /** the function to run when the edit Icon is clicked */
  onClick: () => void;
  /** the function to run when the input is updated */
  onChange: (value: string) => void;
};

const HeaderInputWrapper = styled.div`
  input[type='text'] {
    ${heading3}
  }
`;

const DisplayWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
  flex-direction: row;
  align-items: center;
`;

const StyledForm = styled.form`
  max-width: ${pxToRem(640)};
`;

export const EditableHeaderInput = ({ isEditMode, value, onBlur, onChange, onClick }: Props) => {
  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    onBlur();
  };

  return (
    <HeaderInputWrapper>
      {isEditMode ? (
        <StyledForm onSubmit={handleFormSubmit}>
          <FormField>
            <InputText autoFocus value={value} onChange={onChange} onBlur={onBlur} />
          </FormField>
        </StyledForm>
      ) : (
        <DisplayWrapper>
          <span>{value}</span>
          <GhostButton onClick={onClick}>
            <Edit16 />
          </GhostButton>
        </DisplayWrapper>
      )}
    </HeaderInputWrapper>
  );
};
